import React from "react";
import { motion } from "framer-motion";
import { ArrowRightIcon } from "lucide-react";
import { BUY_URL, scrollToBuy } from "../lib/constants";
type Props = {
  label?: string;
  className?: string;
  onClickBuy?: boolean; // if true, go to checkout link directly
};

// Default behavior: scroll to the purchase section.
export function BuyButton({
  label = "Quiero mi Kit RRHH ahora",
  className = "",
  onClickBuy = false
}: Props) {
  const handleClick = () => {
    if (onClickBuy) {
      window.open(BUY_URL, "_blank", "noopener,noreferrer");
    } else {
      scrollToBuy();
    }
  };
  return <motion.button type="button" onClick={handleClick} whileHover={{
    scale: 1.03
  }} whileTap={{
    scale: 0.97
  }} animate={{
    scale: [1, 1.02, 1]
  }} transition={{
    repeat: Infinity,
    duration: 2.4,
    ease: "easeInOut"
  }} className={`group inline-flex w-full items-center justify-center gap-2 rounded-full bg-[#c7a24a] px-6 py-4 text-base font-extrabold uppercase tracking-wide text-[#1f2d24] shadow-lg shadow-[#c7a24a]/40 transition-colors hover:bg-[#d8b45c] ${className}`} data-id="element-117" data-mp="3c80yufarca1c">
      {label}
      <ArrowRightIcon className="h-5 w-5 transition-transform group-hover:translate-x-1" data-id="element-118" data-mp="1c924osopz5tx" />
    </motion.button>;
}